<template>
  <form class="form" v-valid.prevent="submit">
    <div class="form-item">
      <label class="cf login-db">
       <svg class="login-icon" style="font-size: 1.3em;left: -0.6em;"><use xlink:href="#phone"/></svg>
        <input class="mr" type="tel" name="mobile" maxlength="11" required="required" pattern="1\d{10}"
               data-required="请填写手机号" data-pattern="手机号填写错误" v-model="tel" placeholder="请输入手机号码"/>
      </label>
    </div>
    <div class="form-item mt1">
      <label class="cf login-db">
        <svg class="login-icon"><use xlink:href="#password"/></svg>
        <input class="mr code-inp" type="password" name="pwd" maxlength="50" required="required" pattern=".{6,}"
               data-required="请填写密码" data-pattern="密码填写错误" v-model="pwd" placeholder="请输入密码"/>
      </label>
    </div>
    <p class="c3 r">
      <router-link class="mr" to="/member/forget">忘记密码</router-link>
    </p>

    <div class="form-item" style="margin-top: 1em">
      <input type="hidden" name="type" value="1"/>
      <input class="border-btn on" type="submit" ref="doSubmit" name="submit" value="登录"/>
    </div>
  </form>
</template>

<script>
  import user from "./user";

  export default {
    data() {
      return {
        api: "api/user-loginbypwd", 
        tel: "",
        pwd: "",
        code: ""
      };
    },
    methods: {
      success(userinfo) {
        this.$router.go(-1);
        this.tel = "";
        this.pwd = "";
        this.code = "";
        this.complete();
        this.$emit("success", userinfo);
      },
      fail(err) {
        this.complete();
        this.$tip(err);
        this.$emit("fail", err);
      },
      complete() {
        var btn = this.$refs.doSubmit;
        btn.disabled = false;
        btn.value = "登录";
      },
      submit() {
        var data = {
            mobile: this.tel,
            password: this.pwd,
            code: this.code
          },
          btn = this.$refs.doSubmit;
        btn.disabled = true;
        btn.value = "发送中...";
        user.on("fail", this.fail)
          .on("success", this.success)
          .login(this.api, data);
      }
    }
  };
</script>
<style lang="less">
  .reg-link {
    color: #00b38b;
  }
  .login-icon {
    position: relative;
    left: -1em;
    top: 0.4em;
    width: 1.4em;
    height: 1.4em;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/form-pwd.vue